export function mergeSortedAndUnsorted<T>(
  sortedArray: T[],
  unsortedArray: T[],
  comparator?: (a: T, b: T) => number,
): T[] {
  const sortedUnsortedArray = unsortedArray.sort(comparator)
  const merged: T[] = []
  let i = 0
  let j = 0

  while (i < sortedArray.length && j < sortedUnsortedArray.length) {
    const compareResult = comparator
      ? comparator(sortedArray[i], sortedUnsortedArray[j])
      : sortedArray[i] < sortedUnsortedArray[j]
        ? -1
        : 1

    if (compareResult <= 0) {
      // eslint-disable-next-line no-plusplus
      merged.push(sortedArray[i++])
    } else {
      // eslint-disable-next-line no-plusplus
      merged.push(sortedUnsortedArray[j++])
    }
  }

  // eslint-disable-next-line no-plusplus
  while (i < sortedArray.length) merged.push(sortedArray[i++])
  // eslint-disable-next-line no-plusplus
  while (j < sortedUnsortedArray.length) merged.push(sortedUnsortedArray[j++])

  return merged
}
